import React from 'react'

import InviteSelect from 'components/shared/InviteSelect'

import './style.styl'

const TargetingExcludes = ({ value, options, onChange, isEmailPlaybook }) => (
  <div className="playbook-segment-select">
    <header className="playbook-title-header">
      <h2>Which segments should {isEmailPlaybook ? 'be excluded' : 'be excluded from this Playbook'}?</h2>
      <p>{isEmailPlaybook ? 'When you enroll contacts in this sales sequence from Drift, Salesforce, or our Gmail extension, any contacts in the following segments will be excluded.' : 'Never show or allow contacts in the following segments to be enrolled in this Playbook:'}</p>
    </header>

    {isEmailPlaybook &&
      <p className="playbook-email-exclusion-description">
        Never send this email to the following segments:
      </p>
    }
    <InviteSelect
      onChange={onChange}
      value={value}
      options={options}
      optionRenderer={({ label }) => label}
      valueRenderer={({ label }) => label}
      selectOptions={{ filterOption: (option, filterText) => option.name.toLowerCase().includes(filterText) }}
      showInviteTips={false}
      shouldSelectAutofocus={false}
    />
  </div>
)

export default TargetingExcludes



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingExcludes/component.js